 //const ADMIN_APIS_URL = "http://localhost:8080/api/sales";
 //const ADMIN_BASE_URL = "http://localhost:8082/";
 const ADMIN_BASE_URL = "https://miniappsadm.callupapp.co/";
// const ADMIN_APIS_URL = "http://localhost:8080/";
export const constants = {
    ADMIN_BASE_URL
    
};
